var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{attrs:{"href":_vm.product.url}},[_c('img',{attrs:{"src":_vm.product.images['255x255'][0]}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.product.name))]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.displayPrice())}})])])}
var staticRenderFns = []

export { render, staticRenderFns }